import * as React from "react";
import { NavLink, RouteComponentProps, withRouter } from "react-router-dom";
import * as AuthenticationStore from "../store/AuthenticationReducer";
import * as SKUStore from "../store/SKUReducer";
import * as POCStore from "../store/POCReducer";
import { ApplicationState } from "store";
import { connect } from "react-redux";
import * as actions from "components/Utils/actions";
import Dropdown from "./Dropdown";
import DropdownLanguage from "./DropdownLanguage";
import { LogoutIcon, ReportsIcon } from "../svg";
import moment from "moment";
import { bindActionCreators } from "redux";

import * as roles from "components/Utils/actions";
import { USER_ROLES } from "components/Utils/actions";
import i18next from "i18next";
import { MenuProps } from "antd";
import FinancialInfoNavItem from "./NavigationItems/FinancialInfoNavItem";
import DeletionNavItem from "./NavigationItems/DeletionNavItem";
import ProductMasterDataNavItem from "./NavigationItems/ProductMasterDataNavItem";
import OrdersNavItem from "./NavigationItems/OrdersNavItem";
import { Header, Nav } from "./NavigationItems/styles";
import AvatarNavItem from "./NavigationItems/AvatarNavItem";
import DataLoaderMenu from "./NavigationItems/DataLoaderMenu";
import ManageAdminNavItem from "./NavigationItems/ManageAdminNavItem";
import ManageTenantsNavItem from "./NavigationItems/ManageTenantsNavItem";
import PocNavItem from "./NavigationItems/PocNavItem";
import SkuNavItem from "./NavigationItems/SkuNavItem";
import UserNavItem from "./NavigationItems/UsersNavItem";
import ManageDistributorsNavItem from "./NavigationItems/ManageDistributorsNavItem";
import ReportsNavItem from "./NavigationItems/ReportsNavItem";
import LogisticsInfoNavItem from "./NavigationItems/LogisticsInfoNavItem";

type AuthenticationProps = AuthenticationStore.AuthenticationState &
  typeof AuthenticationStore.actionCreators &
  RouteComponentProps<{}>;

class NavMenu extends React.PureComponent<any> {
  constructor(props) {
    super(props);
    var userRole = actions.getUserRole();
    if (userRole) {
      this.props.authenticationActions.getCurrentLoggedUser();
      this.props.authenticationActions.changeAuthentication(true);
    }
    Date.prototype.toJSON = function () {
      return moment(this).format("YYYY-MM-DD");
    };
  }

  public state = {
    isOpen: false,
    unmappedSKUItemsCount: null,
    unmappedPOCItemsCount: null,
  };

  componentDidMount() {
    let userRole = actions.getUserRole();
    if (
      userRole === USER_ROLES.DATA_LOADER ||
      userRole === USER_ROLES.CUSTOMER_SERVICE
    ) {
      return;
    }
    this.props.pocActions.getPocUnmappedItems();
    if (userRole === USER_ROLES.TENANT_ADMIN) {
      this.props.skuActions.getUnmappedItems();
    }
  }

  public render() {
    const { isAuthenticated } = this.props.authenticationState;
    var userRole = actions.getUserRole();
    var userName = this.props.authenticationState.currentUserInfo;

    if (isAuthenticated && !userRole) {
      this.props.authenticationActions.changeAuthentication(false);
      this.props.history.push("/");
    }

    const reports = {
      [USER_ROLES.TENANT_SUPPORT]: [
        {
          to: "/whs-data-report",
          label: i18next.t("whs_data_report"),
        },
      ],
      [USER_ROLES.CUSTOMER_SERVICE]: [
        {
          to: "/marketplace-reports",
          label: i18next.t("marketplace_reports"),
        },
      ],
      [USER_ROLES.TENANT_ADMIN]: [
        {
          to: "/received-sales-files-report",
          label: i18next.t("received_sales_files"),
        },
        {
          to: "/depot-raw-data-report",
          label: i18next.t("depot_raw_data"),
        },
        {
          to: "/whs-data-report",
          label: i18next.t("whs_data_report"),
        },
        {
          to: "/generating-sales-report",
          label: i18next.t("sales_report"),
        },
        {
          to: "/whs-stock-report",
          label: i18next.t("whs_stock_report"),
        },
        {
          to: "/uploaded-files-report",
          label: i18next.t("uploaded_files_report"),
        },
        {
          to: "/poc-mapping-history",
          label: i18next.t("poc_mapping_history"),
        },
        {
          to: "/sku-mapping-history",
          label: i18next.t("sku_mapping_history"),
        },
        {
          to: "/monthly-raw-sales-report",
          label: i18next.t("monthly_raw_sales_report"),
        },
        {
          to: "/marketplace-reports",
          label: i18next.t("marketplace_reports"),
        },
      ],
      [USER_ROLES.TENANT_SUPERVISOR]: [
        {
          to: "/whs-data-report",
          label: i18next.t("whs_data_report"),
        },
        {
          to: "/generating-sales-report",
          label: i18next.t("sales_report"),
        },
        {
          to: "/whs-stock-report",
          label: i18next.t("whs_stock_report"),
        },
        {
          to: "/monthly-raw-sales-report",
          label: i18next.t("monthly_raw_sales_report"),
        },
        {
          to: "/marketplace-reports",
          label: i18next.t("marketplace_reports"),
        },
      ],
    };

    const Loader = () => <div className="loader" />;

    const role = roles.getUserRole();
    let logoRedirectTo = "/dashboard";
    switch (role) {
      case USER_ROLES.ADMINISTRATOR:
        logoRedirectTo = "/manage-tenants";
        break;
      case USER_ROLES.CUSTOMER_SERVICE:
        logoRedirectTo = "/manage-distributors";
        break;
      case USER_ROLES.TENANT_SUPERVISOR:
        logoRedirectTo = "/orders";
        break;
      case USER_ROLES.DATA_LOADER:
        logoRedirectTo = "/data-load";
        break;
    }

    const items: MenuProps["items"] = [
      {
        key: "1",
        label: (
          <NavLink to="/logout" onClick={this.logout} style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: 18, height: 24, marginRight: 10 }}>
              <LogoutIcon />
            </div>
            {i18next.t("logout")}
          </NavLink>
        ),
      },
    ];

    return isAuthenticated ? (
      <Header>
        <Nav>
          <div>
            <FinancialInfoNavItem
              isVisible={
                userRole === USER_ROLES.TENANT_ADMIN ||
                userRole === USER_ROLES.TENANT_SUPERVISOR ||
                userRole === USER_ROLES.CUSTOMER_SERVICE ||
                userRole === USER_ROLES.DISTRIBUTOR
              }
            />

            <LogisticsInfoNavItem
              isVisible={
                userRole === USER_ROLES.TENANT_ADMIN ||
                userRole === USER_ROLES.TENANT_SUPERVISOR ||
                userRole === USER_ROLES.CUSTOMER_SERVICE ||
                userRole === USER_ROLES.DISTRIBUTOR
              }
            />

            <DeletionNavItem isVisible={userRole === USER_ROLES.TENANT_ADMIN} />

            <ProductMasterDataNavItem
              isVisible={
                userRole === USER_ROLES.TENANT_ADMIN ||
                userRole === USER_ROLES.TENANT_SUPERVISOR ||
                userRole === USER_ROLES.ADMINISTRATOR ||
                userRole === USER_ROLES.CUSTOMER_SERVICE
              }
              items={
                userRole !== USER_ROLES.TENANT_SUPERVISOR
                  ? [
                      { to: "/products", label: i18next.t("products") },
                      { to: "/pallets", label: i18next.t("pallets") },
                      { to: "/packaging", label: i18next.t("packaging") },
                      {
                        to: "/upload-products-data",
                        label: i18next.t("upload"),
                      },
                    ]
                  : [
                      { to: "/products", label: i18next.t("products") },
                      {
                        to: "/upload-products-data",
                        label: i18next.t("upload"),
                      },
                    ]
              }
            />

            <OrdersNavItem
              isVisible={
                userRole === USER_ROLES.TENANT_ADMIN ||
                userRole === USER_ROLES.TENANT_SUPERVISOR ||
                userRole === USER_ROLES.ADMINISTRATOR ||
                userRole === USER_ROLES.CUSTOMER_SERVICE
              }
              userRole={userRole}
            />

            <PocNavItem
              isVisible={
                userRole !== USER_ROLES.ADMINISTRATOR &&
                userRole !== USER_ROLES.DATA_LOADER &&
                userRole !== USER_ROLES.TENANT_SUPERVISOR &&
                userRole !== USER_ROLES.CUSTOMER_SERVICE &&
                userRole !== USER_ROLES.DISTRIBUTOR
              }
              unmappedItems={this.props.pocState.unmappedItems}
            />

            <SkuNavItem
              isVisible={userRole === USER_ROLES.TENANT_ADMIN}
              countOfMissingSkuMappings={
                this.props.skuState.unmappedItems?.countOfMissingSkuMappings
              }
            />

            <ReportsNavItem
              isVisible={
                userRole === USER_ROLES.TENANT_ADMIN ||
                userRole === USER_ROLES.TENANT_SUPERVISOR ||
                userRole === USER_ROLES.TENANT_SUPPORT ||
                userRole === USER_ROLES.CUSTOMER_SERVICE
              }
              items={reports[userRole]}
            />

            <UserNavItem isVisible={userRole === USER_ROLES.TENANT_ADMIN} />

            <ManageDistributorsNavItem
              isVisible={
                userRole === USER_ROLES.TENANT_ADMIN ||
                userRole === USER_ROLES.CUSTOMER_SERVICE
              }
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DropdownLanguage />

            <AvatarNavItem
              isVisible={this.props.authenticationState.currentUserInfo}
              items={items}
              userName={userName}
              userRole={userRole}
            />
          </div>

          {userRole === USER_ROLES.ADMINISTRATOR && (
            <>
              <ManageTenantsNavItem />

              <ManageAdminNavItem />

              <AvatarNavItem
                isVisible={this.props.authenticationState.currentUserInfo}
                items={items}
                userName={userName}
                userRole={userRole}
              />
            </>
          )}

          {userRole === USER_ROLES.DATA_LOADER && (
            <DataLoaderMenu>
              <AvatarNavItem
                isVisible={this.props.authenticationState.currentUserInfo}
                items={items}
                userName={userName}
                userRole={userRole}
              />
            </DataLoaderMenu>
          )}
        </Nav>
      </Header>
    ) : null;
  }

  private logout = (event) => {
    event.preventDefault();
    this.props.authenticationActions.removeAuthentication();
    this.props.authenticationActions.changeAuthentication(false);
    this.props.history.push("/");
  };
}

function mapStateToProps(state: ApplicationState) {
  return {
    authenticationState: state.authentication,
    skuState: state.sku,
    pocState: state.poc,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    authenticationActions: bindActionCreators(
      AuthenticationStore.actionCreators,
      dispatch
    ),
    skuActions: bindActionCreators(SKUStore.actionCreators, dispatch),
    pocActions: bindActionCreators(POCStore.actionCreators, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavMenu)
);
